// extracted by mini-css-extract-plugin
module.exports = {"categories":"categories_categories__oaqcs"};